import { TableTitleBox, PaginationTable } from '../../../common/components';
import { DIFFERIMENT_INVOICES_TITLE } from './constants/differimentInvoicesConstants';
import DifferimentInvoicesFilters from './components/DifferimentInvoicesFilters';
import DifferimentInvoicesTable from './components/DifferimentInvoicesTable';
import { useDifferimentInvoicePrint } from '../../../hooks/useDifferimentInvoices';
import { useDifferimentInvoicesTable } from './hooks/useDifferimentInvoicesTable';

const DifferimentInvoices = () => {
  const {
    filters,
    rows,
    isFetching,
    totalCount,
    totalPages,
    handleChange,
    handleFetch,
  } = useDifferimentInvoicesTable();
  const printMutation = useDifferimentInvoicePrint();

  return (
    <div>
      <TableTitleBox title={DIFFERIMENT_INVOICES_TITLE} />
      <DifferimentInvoicesFilters
        filters={filters}
        onChange={handleChange}
        onFetch={handleFetch}
        isFetching={isFetching}
      />

      <DifferimentInvoicesTable
        rows={rows}
        isFetching={isFetching}
        onPrint={(uuid) => printMutation.mutate(uuid)}
        isPrinting={printMutation.isLoading}
      />

      <PaginationTable
        page={filters.page}
        rowsPerPage={filters.limit}
        totalCount={totalCount}
        totalPages={totalPages}
        onRowsPerPageChange={(e) => handleChange('limit', Number(e.target.value))}
        onPageChange={(_, value) => handleChange('page', value)}
      />
    </div>
  );
};

export default DifferimentInvoices;
